import { tz } from '@fareye/utils'
import React from 'react'
import { DateRangePicker } from 'react-date-range'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import styled from 'styled-components'
import { Button, Flex } from '../main'
import { IDateRangeSelectorModalProps } from '../utility/types'
import { background } from 'styled-system'

const DatePicker = styled(DateRangePicker)`
  .rdrDefinedRangesWrapper {
    @media (max-width: 540px) {
      display: none;
    }
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: ${(props: any) => props.color};
  }
`

const DateRangeWrapper = styled.div`
  font-size: 14px;
  background: #fff;
  transform: scale(0.8, 0.8);
  transform-origin: top left;
`

export default function DateRangeSelectorModal({
  value,
  minDate,
  maxDate = new Date(),
  formatter,
  className = '',
  onDateRangeSelected,
  toggleModal,
  color
}: IDateRangeSelectorModalProps) {
  const [selectionRange, setSelectionRange] = React.useState({
    startDate: value.startDate,
    endDate: value.endDate
  })

  React.useEffect(() => {
    setSelectionRange({
      startDate: value.startDate,
      endDate: value.endDate
    })
  }, [value.startDate, value.endDate])

  function handleSelect(ranges: any) {
    const formatDateforTimeRemoval = (date: Date): Date => {
      const t = date
      return new Date(
        (t.getMonth() + 1 + '-' + t.getDate() + '-' + t.getFullYear()).replace(
          /-/g,
          '/'
        )
      )
    }
    let sd = formatDateforTimeRemoval(ranges.range1.startDate)
    let ed = formatDateforTimeRemoval(ranges.range1.endDate)
    if (maxDate) {
      ed = maxDate < ed ? new Date(maxDate) : ed
    }
    if (minDate) {
      sd = minDate > sd ? new Date(minDate) : sd
    }
    setSelectionRange({
      startDate: sd,
      endDate: ed
    })
  }
  const dateIsChanged =
    value.startDate !== selectionRange.startDate ||
    value.endDate !== selectionRange.endDate

  return (
    <DateRangeWrapper>
      <Flex column>
        <DatePicker
          ranges={[
            {
              startDate:
                typeof selectionRange.startDate === 'object'
                  ? selectionRange.startDate
                  : tz(new Date(selectionRange.startDate)),
              endDate:
                typeof selectionRange.endDate === 'object'
                  ? selectionRange.endDate
                  : tz(new Date(selectionRange.endDate))
            }
          ]}
          onChange={handleSelect}
          maxDate={maxDate}
          minDate={minDate}
          direction="horizontal"
          rangeColors = {[color]}
          color = {color}
          todayColor = {color}
        />
        <Flex
          justifyContentFlexEnd
          style={{ padding: '0 10px 10px', marginTop: '-10px' }}
        >
          <Button
            variant="default m"
            onClick={() => {
              toggleModal()
              setSelectionRange({
                startDate: value.startDate,
                endDate: value.endDate
              })
            }}
          >
            Cancel
          </Button>
          {dateIsChanged && (
            <Button
              variant="primary m"
              style={{ marginLeft: 10, background: color }}
              onClick={() => {
                toggleModal()
                onDateRangeSelected({
                  startDate: formatter
                    ? formatter(selectionRange.startDate)
                    : selectionRange.startDate,
                  endDate: formatter
                    ? formatter(selectionRange.endDate)
                    : selectionRange.endDate
                })
              }}
            >
              Apply
            </Button>
          )}
        </Flex>
      </Flex>
    </DateRangeWrapper>
  )
}
